/**
 * Libs
 */
import { useCallback, useState } from 'react';
import { CollectionAPI, ICollection } from '@tacans/shared-marketplace-layer';

export const useFetchLatestCollections = () => {
    const [loading, setLoading] = useState(false);
    const [collections, setCollections] = useState<ICollection[]>([]);

    const fetchCollections = useCallback(async () => {
        try {
            setLoading(true);

            const { data } = await CollectionAPI.fetchByFilter({
                sorting: {
                    sortBy: 'Date',
                    ascending: false
                },
                filter: {},
                pager: {
                    limit: 3
                }
            });

            if (data.responseMeta.status === 'OK') {
                setCollections(data.collections ?? []);
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('fetchLatestCollections', error);
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        loading,
        collections,
        fetchCollections
    };
};
